import CheckButton from './../../global/CheckButton/CheckButton'; // Componentes
import './Payment.css'; // CSS
import PlusIcon from './../../../img/warning-icon.svg'; // /IMGs

function Payment({options, onMarkOption}) {
    return (
        <div className="payment">
            <h2 className="payment__title">
                Escolha uma forma de pagamento
            </h2>

            <div className="payment__options">
                {options.map(option => (
                    <div className="payment__option" onClick={() => onMarkOption(option.id)}>
                        <CheckButton
                            width={20}
                            check={option.mark}
                            borderColor="#ac4b1c"
                            backgroundColor="#fca652" />

                        <span className="payment__option-name">
                            {option.name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Payment;